module.exports = __webpack_public_path__ + "img/img-1.bccc53c4.jpg";